import ChatSDKConfig from '@microsoft/omnichannel-chat-sdk/lib/core/ChatSDKConfig';
import fetch from 'globals/wa-fetch';

export const getChatSDKConfig = (): ChatSDKConfig => ({
  chatReconnect: {
    disable: false,
  },
  telemetry: { disable: true },
  persistentChat: {
    disable: false,
    tokenUpdateTime: 21600000, // ASYNC_CHAT_TODO: Replace with desired tokenUpdateTime
  },
  getAuthToken: async () => {
    try {
      const response = await fetch('/token/async-chat', {
        token: true,
        method: 'post',
      });
      return response?.body?.token;
    } catch (e) {
      // ASYNC_CHAT_TODO: Determine what to do /display to user when we can't fetch chat token
    }
  },
});
